<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">AIS140 Ticket TML Request Logs</span>
    </div>
  </div>

  <div class="component-container">
    <!-- List Section -->
    <form [formGroup]="tmlRequestLogsForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">AIS140 Ticket TML Request Logs List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="
              tmlRequestLogsForm?.get('batchListSearch')?.value
            "
            matTooltip="VIN  NO. | ICCID  NO. | UIN  NO."
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>VIN NO.</th>
              <th>ICCID NO.</th>
              <th>UIN NO.</th>
              <th>Sent By</th>
              <th>Response</th>
              <th>Payload</th>
              <th>Sent AT</th>
            </tr>
          </thead>
          @if (listOfBatch.length !== 0) {
            <tbody>
              @for (
                deviceValue of listOfBatch
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track deviceValue
              ) {
                <tr>
                  <td>{{ deviceValue.vin ? deviceValue.vin : '--' }}</td>
                  <td>
                    {{ deviceValue.iccid ? deviceValue.iccid : '--' }}
                  </td>
                  <td>{{ deviceValue.uin ? deviceValue.uin : '--' }}</td>
                  <td>{{ deviceValue.payloadType }}</td>
                  <td>{{ deviceValue.response_code }}</td>
                  <td>{{ deviceValue.payload | json }}</td>
                  <td>{{ deviceValue.timestamp | date: 'medium' }}</td>
                </tr>
              }
            </tbody>
          }
          @if (listOfBatch.length === 0) {
            <tbody>
              <tr>
                <td colspan="7">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (listOfBatch.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </form>
  </div>
</div>
